/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import SegmentCategoryListInner from './SegmentCategoryListInner'

/**
 * The SegmentCategoryList model module.
 * @module model/SegmentCategoryList
 * @version 1.0.0
 */
export default class SegmentCategoryList extends Array {
  /**
   * Constructs a new <code>SegmentCategoryList</code>.
   * @alias module:model/SegmentCategoryList
   * @class
   * @extends Array
   */

  constructor() {
    super()

    return this
  }

  /**
   * Constructs a <code>SegmentCategoryList</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SegmentCategoryList} obj Optional instance to populate.
   * @return {module:model/SegmentCategoryList} The populated <code>SegmentCategoryList</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SegmentCategoryList()

      ApiClient.constructFromObject(data, obj, 'SegmentCategoryListInner')
    }
    return obj
  }
}
